import { i18n } from '../config';

export default (date, format = 'short') => i18n.global.d(new Date(date), format);
